// 格式化万、股、手等单位
const formatWan = (value, t) => {
  value = Number(value);
  if (!value) return '--';
  var s = (t == 'gu')
    ? '股'
    : (t == 'shou')
      ? '手'
      : '元';
  if (Math.abs(value) < 10000) {
    if (value < 0) {
      return '-' + value + s;
    } else {
      return '+' + value + s;
    }
  } else if (Math.abs(value) >= 10000 && Math.abs(value) < 100000000) {
    if (value < 0) {
      if (s == '元') {
        return '-' + (Math.abs(value) / 10000).toFixed(2) + '万';
      } else {
        return '-' + (Math.abs(value) / 10000).toFixed(2) + '万' + s;
      }
    } else {
      if (s == '元') { 
        return '+' + (Math.abs(value) / 10000).toFixed(2) + '万';
      } else {
        return '+' + (Math.abs(value) / 10000).toFixed(2) + '万' + s;
      }
    }
  } else {
    if (value < 0) {
      if (s == '元') { 
        return '-' + (Math.abs(value) / 100000000).toFixed(2) + '亿';
      } else {
        return '-' + (Math.abs(value) / 100000000).toFixed(2) + '亿' + s;
      }
    } else {
      if (s == '元') { 
        return '+' + (Math.abs(value) / 100000000).toFixed(2) + '亿';
      } else {
        return '+' + (Math.abs(value) / 100000000).toFixed(2) + '亿' + s;
      }
    }
  }
}
// 无+符号 格式化价格
const formatWan2 = (value) => {
  var res = formatWan(value, '').replace(/\+/, '');
  return res;
}
export {formatWan, formatWan2}






// WEBPACK FOOTER //
// ./src/assets/js/formatWan.js